export default {
    type: 'core',
    init: function (GG) {
        GG.callback = this.plugin.bind(GG);
        GG.log('Callback plugin loaded.');
    },
    plugin: function () {
        if (arguments.length < 1)
            return false;
        arguments[0] = arguments[0].split(' ');
        if (!this.callbacks) {
            this.callbacks = {};
        }
        for (var i = 0, k = arguments[0].length; i < k; i++) {
            var ev = arguments[0][i].split('.'), name_1 = '';
            if (ev.length > 1) {
                name_1 = ev[1];
            }
            ev = ev[0];
            if (typeof arguments[1] === 'function') {
                if (name_1 && this.callbacks[ev]) {
                    var _newList = [];
                    for (var j = 0, l = this.callbacks[ev].length; j < l; j++) {
                        if (!this.callbacks[ev][j].n || (this.callbacks[ev][j].n && this.callbacks[ev][j].n !== name_1)) {
                            _newList.push(this.callbacks[ev][j]);
                        }
                    }
                    this.callbacks[ev] = _newList;
                }
                if (!this.callbacks[ev])
                    this.callbacks[ev] = [];
                this.callbacks[ev].push({
                    f: arguments[1],
                    n: name_1
                });
            }
            else {
                if (this.callbacks[ev]) {
                    for (var j = 0, l = this.callbacks[ev].length; j < l; j++) {
                        if ((name_1 && this.callbacks[ev][j].n === name_1) || !name_1) {
                            if (arguments[1] === null) {
                                this.callbacks[ev].splice(j, 1);
                                j = -1;
                                l = this.callbacks[ev].length;
                            }
                            else {
                                this.callbacks[ev][j].f(arguments[1]);
                            }
                        }
                    }
                    if (!this.callbacks[ev].length) {
                        delete this.callbacks[ev];
                    }
                }
            }
        }
    }
};
